import { ENDPOINT } from '@old/data/core/endpoints';
import { BACKEND } from '@old/services/core/fetch-backend';
import { CountrysideEditionPayload, UpdatedCountrysideData } from './countryside-edition.types';
import { transformIntoQueryParamString } from '@old/utils/service';

// deprecated service ref.: updateCountrysideService_DEPRECATED

// ✅ Implementado
export async function updateCountrysideDataService({ query: rawQuery, body }: CountrysideEditionPayload) {
  const query = transformIntoQueryParamString(rawQuery);

  const { response, data } = await BACKEND.put<UpdatedCountrysideData>(ENDPOINT.COUNTRYSIDES, {
    query,
    body,
  });

  return {
    response,
    summary: data,
  };
}
